import { render, staticRenderFns } from "./kTomIndex.vue?vue&type=template&id=b4e5e7bc&"
import script from "./kTomIndex.vue?vue&type=script&lang=js&"
export * from "./kTomIndex.vue?vue&type=script&lang=js&"
import style0 from "./kTomIndex.vue?vue&type=style&index=0&id=b4e5e7bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports